module.exports = __webpack_public_path__ + "img/company-logo-white.5f8655e8.svg";